const COOKIE_PREFIX = 'voyantis_webinar_';
const COOKIE_DAYS = 365;
const SKIP_PARAM = 'gated';
const SKIP_VALUE = 'skip';
const UNLOCK_EVENT = 'voyantis:webinar-unlocked';

function setCookie(name, value, days) {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie = `${name}=${value}; expires=${expires}; path=/; SameSite=Lax`;
}

function getCookie(name) {
  const m = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  return m ? decodeURIComponent(m[1]) : null;
}

export function initWebinarGate() {
  const wrapper = document.querySelector('.webinar-gated_form-wrapper');
  if (!wrapper) return;

  const slug = wrapper.dataset.webinarSlug;
  if (!slug) {
    console.warn('[webinar-gate] Missing data-webinar-slug');
    return;
  }

  const formWrapper = wrapper.querySelector('[data-webinar-form]');
  const videoWrapper = wrapper.querySelector('[data-webinar-video]');

  if (!formWrapper || !videoWrapper) {
    console.warn('[webinar-gate] Missing form or video wrapper');
    return;
  }

  const cookieName = COOKIE_PREFIX + slug;
  const skipRequested = new URLSearchParams(window.location.search).get(SKIP_PARAM) === SKIP_VALUE;

  function unlock(scroll = false) {
    setCookie(cookieName, '1', COOKIE_DAYS);

    const layout = wrapper.parentElement;

    wrapper.style.display = 'none';
    layout.style.flexDirection = 'column';

    layout.appendChild(videoWrapper);
    videoWrapper.style.display = 'block';
    videoWrapper.style.width = '100%';

    const iframe = videoWrapper.querySelector('iframe');
    if (iframe) {
      iframe.removeAttribute('width');
      iframe.removeAttribute('height');
      iframe.style.width = '100%';
      iframe.style.height = 'auto';
      iframe.style.aspectRatio = '16 / 9';
    }

    if (scroll) {
      videoWrapper.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  // Already unlocked via cookie or ?gated=skip
  if (getCookie(cookieName) || skipRequested) {
    unlock();
    return;
  }

  // Otherwise, wait for HubSpot form submission
  document.addEventListener(UNLOCK_EVENT, () => unlock(true), { once: true });
}
